import request, { METHODS } from "src/utils/api-base";

const adjustmentOrderApis = {
  create: (payload: any) =>
    request({
      route: "/app/adjustment-order/create",
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  list: (params?: any) =>
    request({
      route: "/app/adjustment-order/list",
      method: METHODS.GET,
      params,
      auth: true,
    }),
};

export default adjustmentOrderApis;
